import React from "react"
import { Switch, Route } from "react-router-dom"
import Header from "../../components/header"
import Sidebar from "../../components/sidebar"
import ErrorContainer from "../Error/404"
import PersonalSettingsContainer from "./PersonalSettings"
import TeamSettingsContainer from "./TeamSettings"

const AccountContainer: React.FC = () => {
  return (
    <>
      <Header />
      <div className="tw-has-header tw-has-sidebar">
        <div className="xl:tw-container tw-mx-auto tw-w-full tw-px-4 sm:tw-px-12">
          <Switch>
            <Route exact path="/account" component={PersonalSettingsContainer} />
            <Route exact path="/account/team" component={TeamSettingsContainer} />
            {/* Error page */}
            <Route path="*" component={ErrorContainer} />
          </Switch>
        </div>
      </div>
      <Sidebar type="account" />
    </>
  )
}

export default AccountContainer
